import { createContext } from 'react';

import { Message, StoredMessage } from './types';

export const UserDebugContext = createContext<{
  messages: StoredMessage[];
  logDebugMessage: (msg: Message) => void;
}>({
  messages: [],
  logDebugMessage: () => {},
});
